export default function RentalPlans() {
  return (
    <section id="plans" className="py-24 bg-gray-50">
      <div className="max-w-7xl mx-auto px-8">
        <div className="mb-16">
          <div className="text-xs text-gray-500 font-light mb-3 tracking-wider">PRICING PLAN</div>
          <h2 className="text-5xl font-extrabold text-gray-900 leading-tight">
            <a href="#plans" className="hover:text-[#14B8A6] transition-colors cursor-pointer">
              シンプルで分かりやすい<br />
              料金体系
            </a>
          </h2>
        </div>

        {/* 東京全エリア */}
        <div className="mb-16">
          <div className="bg-gradient-to-r from-gray-700 to-gray-600 text-white text-center py-4 rounded-t-2xl">
            <h3 className="text-2xl font-bold">東京全エリア</h3>
          </div>
          <div className="bg-white rounded-b-2xl p-8 shadow-sm">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-4xl mx-auto">
              <div className="text-center">
                <div className="text-gray-700 text-lg mb-2">モノクロ:</div>
                <div className="text-5xl font-bold text-[#14B8A6] mb-1">
                  2<span className="text-3xl">円</span> / 枚
                </div>
                <div className="text-sm text-gray-500">(税込2.1円)</div>
              </div>
              <div className="text-center">
                <div className="text-gray-700 text-lg mb-2">カラー:</div>
                <div className="text-5xl font-bold text-[#14B8A6] mb-1">
                  12<span className="text-3xl">円</span> / 枚
                </div>
                <div className="text-sm text-gray-500">(税込13.1円)</div>
              </div>
            </div>
          </div>
        </div>

        {/* 要相談エリア */}
        <div className="mb-16">
          <div className="bg-gradient-to-r from-gray-700 to-gray-600 text-white text-center py-4 rounded-t-2xl">
            <h3 className="text-2xl font-bold">要相談エリア</h3>
          </div>
          <div className="bg-white rounded-b-2xl p-8 shadow-sm">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-4xl mx-auto">
              <div className="text-center">
                <div className="text-gray-700 text-lg mb-2">モノクロ:</div>
                <div className="text-5xl font-bold text-[#14B8A6] mb-1">
                  4<span className="text-3xl">円</span> / 枚
                </div>
                <div className="text-sm text-gray-500">(税込4.4円)</div>
              </div>
              <div className="text-center">
                <div className="text-gray-700 text-lg mb-2">カラー:</div>
                <div className="text-5xl font-bold text-[#14B8A6] mb-1">
                  25<span className="text-3xl">円</span> / 枚
                </div>
                <div className="text-sm text-gray-500">(税込27.5円)</div>
              </div>
            </div>
          </div>
        </div>

        {/* 基本最低料金と最低契約期間 */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-4xl mx-auto">
          <div className="bg-white rounded-2xl p-8 shadow-sm">
            <h4 className="text-xl font-bold text-gray-900 mb-4 text-center">基本最低料金</h4>
            <div className="text-center">
              <div className="text-5xl font-bold text-[#14B8A6] mb-2">
                4,000<span className="text-2xl">円</span>
              </div>
              <div className="text-sm text-gray-500 mb-4">(税込 4,400円)</div>
              <div className="text-xs text-gray-600 space-y-1">
                <p>※指定金額相当が4,400円未満の場合は基本料金として 4,400円</p>
                <p>※基本料金差額分は上記単価にてとります。</p>
                <p>※用紙料はお客様ご負担となります</p>
              </div>
            </div>
          </div>

          <div className="bg-white rounded-2xl p-8 shadow-sm">
            <h4 className="text-xl font-bold text-gray-900 mb-4 text-center">最低契約期間</h4>
            <div className="text-center">
              <div className="text-5xl font-bold text-[#14B8A6] mb-2">
                1<span className="text-2xl">年〜</span>
              </div>
              <div className="text-xs text-gray-600 space-y-1 mt-6">
                <p>※ 1年間(12ヶ月)よりとします。</p>
                <p>※ 契約途中解約は違約金が発生します</p>
              </div>
            </div>
          </div>
        </div>

        <div className="text-center mt-12">
          <button
            onClick={() => {
              const contactSection = document.getElementById('contact');
              contactSection?.scrollIntoView({ behavior: 'smooth' });
            }}
            className="bg-gray-900 text-white px-10 py-4 rounded-full text-base font-medium hover:bg-gray-800 transition-colors whitespace-nowrap cursor-pointer"
          >
            お問い合わせはこちら
          </button>
        </div>
      </div>
    </section>
  );
}
